import { Navigate } from 'react-router-dom'
import { useSession } from '@shared/hooks/useSession'
import { ReactNode } from 'react'
import { getAuthEmail } from '@shared/libs/authStorage'

export function EmailVerifyRoute({ children }: { children: ReactNode }) {
  const { data, isLoading } = useSession()
  const localEmail = getAuthEmail()
  if (localEmail) return <>{children}</>
  if (isLoading) return <div className="p-6">Loading…</div>
  if (!data?.needs_email_verify) return <Navigate to="/" replace />
  return <>{children}</>
}
